import myFirebase from '../config/config';
import apiCaller from './apiCallerOutstanding';
import logger from './logger';
import { mappedCurrentActiveRole } from './roleMapping';

export default async function tripActivityLogger(payload) {
  if (!payload) {
    logger.log('tripActivityLogger: payload is missing');
    return;
  }
  const role = mappedCurrentActiveRole(payload?.role);
  const body = {
    ...payload,
    role,
  };
  const endPoint = 'pipe/trip-activity';
  const currentUserDetails = myFirebase.auth().currentUser;
  if (!currentUserDetails) {
    logger.log('tripActivityLogger: No authenticated user');
    return;
  }
  const token = await currentUserDetails.getIdToken();
  try {
    await apiCaller(endPoint, body, `Bearer ${token}`, 'nh-base', 'post');
  } catch (e) {
    logger.log(e);
  }
}
